import CustomInput from './CustomInput.vue'
export default CustomInput


// WEBPACK FOOTER //
// ./src/components/CustomInput/index.js